import { getUserSetApi, setUserSetApi } from '@/tools/get-user-set-api.js'
const getDefaultState = () => {
  const user_set_api = getUserSetApi() || ''
  return {
    inner_height: 0,
    is_pad: false,
    repeat_error_locks: [],
    user_set_api,

    cookieOptions: {
      expires: '1D'
    }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_INNER_HEIGHT: (state, innerHeight) => {
    state.inner_height = innerHeight
  },
  SET_PAD_TAG: (state, is_pad) => {
    state.is_pad = is_pad
    // state.is_pad = true
  },

  SET_COOKIES_OPTIONS: (state, options) => {
    state.cookieOptions = {
      ...(state.cookieOptions || {}),
      ...(options || {})
    }
  },

  ADD_LOCKS: (state, lock) => {
    let repeat_error_locks = state.repeat_error_locks

    console.log(repeat_error_locks, 'repeat_error_locks', 'add')

    repeat_error_locks = Array.from(new Set([...repeat_error_locks, lock]))

    state.repeat_error_locks = repeat_error_locks
  },
  DEL_LOCKS: (state, lock) => {
    const repeat_error_locks = [...state.repeat_error_locks]

    console.log(repeat_error_locks, 'repeat_error_locks', 'del')

    const existLockIndex = repeat_error_locks.findIndex((item) => (item === lock))

    if (existLockIndex > -1) {
      repeat_error_locks.splice(existLockIndex, 1)
      state.repeat_error_locks = repeat_error_locks
    }
  },

  SET_API: (state, user_set_api) => {
    state.user_set_api = user_set_api
  }
}

const actions = {
  // 改变视内高度
  changeInnerHeight ({ commit }, inner_height) {
    commit('SET_INNER_HEIGHT', inner_height)
  },

  // 判断是否是pad
  changeIspadFlag ({ commit }, is_pad) {
    commit('SET_PAD_TAG', is_pad)
  },

  // 设置 pad 本上 元素高度
  setInnerHeightIfPad ({ state }, { domSelector, adjustPx = 0 }) {
    const is_pad = state.is_pad

    const inner_height = state.inner_height

    console.log('inner_height', inner_height)

    if (is_pad && typeof domSelector === 'string') {
      const curDom = document.querySelector(domSelector) || {}

      curDom.style && (curDom.style.height = (inner_height + adjustPx) + 'px')
    }
  },

  // 改变cookie的默认设置
  changeCookieOptions ({ commit }, options) {
    commit('SET_COOKIES_OPTIONS', options)
  },

  // 添加一个要锁的错误信息
  addLockErrorMsg ({ commit }, lock) {
    commit('ADD_LOCKS', lock)
  },
  // 删除一个锁住的错误信息
  delLockErrorMsg ({ commit }, lock) {
    commit('DEL_LOCKS', lock)
  },

  // 设置一个用户的HOST
  changeUserSetApi ({ commit }, user_set_api) {
    commit('SET_API', user_set_api)
    setUserSetApi(user_set_api)
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
